import React, { useState } from 'react'
import { AnimatePresence } from 'framer-motion'
import { Button, Badge } from 'antd'
import { FilterOutlined, SearchOutlined } from '@ant-design/icons'

import Pagination from 'components/Pagination'
import ModalSearch from 'components/Modal/ModalSearch'
import ModalFilterActivityLogs from 'components/Modal/QuickFilters/FilterActivityLogs'

import { useLogContext } from './LogContext'

function TableListHeader() {
  const {
    loading,
    search,
    totalPage,
    currentPage,
    userId,
    dateRange,
    dispatch,
  } = useLogContext()

  const [showSearch, setShowSearch] = useState(false)
  const [showFilter, setShowFilter] = useState(false)

  const handlePageChange = (newPage: number) => {
    dispatch({
      type: 'SET_CURRENT_PAGE',
      payload: newPage,
    })
  }

  const handleSearch = (value: string) => {
    if (value !== search) {
      dispatch({ type: 'SET_SEARCH', payload: value })
    }
  }

  const handleFilter = (filters: { userId?: number; dateRange?: string[] }) => {
    dispatch({ type: 'SET_FILTER', payload: filters })
  }

  return (
    <React.Fragment>
      <div className='table-list-header sticky'>
        <div className='left'>
          <Pagination
            disabled={loading}
            current={currentPage}
            total={totalPage}
            onPageChange={handlePageChange}
          />
        </div>
        <div className='right'>
          <Button
            disabled={loading}
            size='large'
            className='ant-btn-secondary'
            onClick={() => setShowFilter(true)}
          >
            <Badge dot={!!userId || !!dateRange}>
              <FilterOutlined />
            </Badge>
          </Button>
          <Button
            disabled={loading}
            size='large'
            className='ant-btn-secondary'
            onClick={() => setShowSearch(true)}
          >
            <Badge dot={!!search}>
              <SearchOutlined />
            </Badge>
          </Button>
        </div>
      </div>

      <AnimatePresence>
        {showSearch && (
          <ModalSearch
            title='Search Logs'
            placeholder='Search logs'
            value={search}
            onSearch={handleSearch}
            onCancel={() => setShowSearch(false)}
          />
        )}
        {showFilter && (
          <ModalFilterActivityLogs
            userId={userId}
            dateRange={dateRange}
            onChange={handleFilter}
            onCancel={() => setShowFilter(false)}
          />
        )}
      </AnimatePresence>
    </React.Fragment>
  )
}

export default TableListHeader
